import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Surface this loudly during development so a misconfigured .env.local
  // doesn't silently produce confusing auth errors later.
  // eslint-disable-next-line no-console
  console.error(
    'Missing Supabase env vars. Copy .env.example to .env.local and fill them in.'
  );
}

/**
 * True when this page load came from a signup-confirmation email link
 * (Supabase appends `#...type=signup` to the redirect). Captured HERE,
 * before createClient runs, because detectSessionInUrl strips the hash
 * as soon as the client boots. Used by App.tsx to send people who
 * signed up in the iPhone/Android app to /email-confirmed ("go back to
 * the app") instead of carrying on inside the mobile browser.
 */
export const landedFromSignupConfirm: boolean = (() => {
  try {
    return /(^|[#&])type=signup(&|$)/.test(window.location.hash);
  } catch {
    return false;
  }
})();

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
